import { render } from "./page404.vue?vue&type=template&id=e6f7943c"
import script from "./page404.vue?vue&type=script&lang=js"
export * from "./page404.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__